import { Form, FormValues } from '@fulcrumapp/fulcrum-core';
import DataViewSource from '../data-view/models/data-view-source';
import { GeometricShape } from '../types/geo';
import Colorizer, { PARENT_COLOR } from './colorizer';
import { GraphicStyle } from './graphic-styles';

export interface GeographicRecord {
  color: string;
  geometry: GeometricShape;
  style?: GraphicStyle;
}

export interface DataViewSourceRecord {
  id: string,
  data?: { parent?: boolean };
  geometry?: GeometricShape;
  status?: string;
}

export interface FeatureProp {
  id: string,
  status: string,
  form?: Form,
  element?: {
    parent: Form,
  }
}

const DataFetcher = (feature: FeatureProp, status: string, source: DataViewSource) => {
  const { form, element } = feature;
  const colorizer = form ? Colorizer(form) : Colorizer(element!.parent);

  const fetchNearbyRecords = async (excludedIds?: string[]): Promise<GeographicRecord[]> => new Promise((resolve) => {
    const nearbyRecords: GeographicRecord[] = [];
    const done = () => { resolve(nearbyRecords); };
    const handler = (row) => {
      if (feature.id !== row.id && !excludedIds?.includes(row.id)) {
        nearbyRecords.push({
          color: colorizer.getColor(row.status),
          geometry: row.geometry,
        });
      }
    };

    source.eachRow(handler, done, done);
  });

  const fetchSiblingRepeatables = (parentValues: FormValues) => {
    const siblingRepeatables: GeographicRecord[] = [];
    const repeatableItems = parentValues?.all.find((item) => item.element?.type === 'Repeatable');

    repeatableItems?.items.forEach((repeatableItem) => {
      if (feature.id !== repeatableItem.id) {
        siblingRepeatables.push({
          color: colorizer.getColor(status),
          geometry: repeatableItem.geometry,
        });
      }
    });

    return siblingRepeatables;
  };

  const fetchParentAndSiblings = (parentValues: FormValues, parentGeometry: GeometricShape) => {
    const nearbyRecords: GeographicRecord[] = fetchSiblingRepeatables(parentValues);

    if (parentGeometry) {
      nearbyRecords.push({
        color: PARENT_COLOR,
        geometry: parentGeometry,
        style: GraphicStyle.PARENT_GEOMETRY,
      });
    }

    return nearbyRecords;
  };

  return {
    fetchNearbyRecords,
    fetchParentAndSiblings,
  };
};

export default DataFetcher;
